import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { 
  FaServer, 
  FaShieldAlt, 
  FaLaptopCode, 
  FaCloudUploadAlt, 
  FaNetworkWired,
  FaUsersCog,
  FaArrowRight
} from 'react-icons/fa';
import { Card, CardBody, CardHeader, CardFooter, Divider, Button, Chip, Modal, ModalContent, ModalHeader, ModalBody, ModalFooter } from "@heroui/react";

const Services = () => {
  // Stan dla aktywnej kategorii (jeśli używasz filtrowania)
  //const [activeCategory, setActiveCategory] = useState('all');
  
  // Stan dla modala
  const [selectedService, setSelectedService] = useState(null);
  
  // Dane o usługach - dostosowane do mniejszej firmy
  const services = [
    {
      id: 'infrastructure',
      icon: <FaServer size={36} />,
      title: 'Infrastruktura IT',
      description: 'Proste i niezawodne rozwiązania serwerowe i sieciowe dla małych, średnich i dużych firm.',
      category: 'infrastructure',
      color: 'primary',
      link: '/uslugi/infrastruktura',
      buttonText: 'Dowiedz się więcej',
      detailedDescription: 'Nasza oferta infrastruktury IT obejmuje kompleksowe rozwiązania serwerowe, sieciowe oraz sprzętowe. Pomagamy w doborze odpowiedniego sprzętu, jego konfiguracji oraz późniejszym utrzymaniu. Oferujemy również usługi wirtualizacji, tworzenia kopii zapasowych oraz implementacji rozwiązań wysokiej dostępności.'
    },
    {
      id: 'security',
      icon: <FaShieldAlt size={36} />,
      title: 'Bezpieczeństwo IT',
      description: 'Ochrona danych i systemów dostosowana do potrzeb i możliwości Twojej firmy.',
      category: 'security',
      color: 'danger',
      link: '/uslugi/bezpieczenstwo',
      buttonText: 'Zabezpiecz swoją firmę',
      detailedDescription: 'Kompleksowe zabezpieczenie Twojej firmy przed cyberatakami, wyciekiem danych i innymi zagrożeniami. Oferujemy audyty bezpieczeństwa, wdrażanie systemów zabezpieczeń, szkolenia pracowników oraz monitoring i reagowanie na incydenty bezpieczeństwa.'
    },
    {
      id: 'development',
      icon: <FaLaptopCode size={36} />,
      title: 'Strony i Aplikacje',
      description: 'Tworzenie przystępnych i funkcjonalnych stron internetowych oraz aplikacji dla twojego biznesu.',
      category: 'software',
      color: 'success',
      link: '/uslugi/programowanie',
      buttonText: 'Sprawdź nasze rozwiązania',
      detailedDescription: 'Projektujemy i rozwijamy nowoczesne strony internetowe oraz aplikacje webowe i mobilne, które są dopasowane do potrzeb Twojego biznesu. Kładziemy nacisk na intuicyjny interfejs, responsywność oraz wydajność naszych rozwiązań.'
    },
    {
      id: 'cloud',
      icon: <FaCloudUploadAlt size={36} />,
      title: 'Rozwiązania Chmurowe',
      description: 'Migracja do chmury i wdrożenie bezpiecznych rozwiązań zwiększających elastyczność pracy.',
      category: 'infrastructure',
      color: 'secondary',
      link: '/uslugi/chmura',
      buttonText: 'Poznaj korzyści chmury',
      detailedDescription: 'Przeprowadzamy migrację do chmury, implementujemy rozwiązania chmurowe oraz zapewniamy ich utrzymanie. Dzięki naszym usługom zyskasz większą elastyczność pracy, skalowalność oraz dostęp do danych i aplikacji z dowolnego miejsca na świecie.'
    },
    {
      id: 'support',
      icon: <FaUsersCog size={36} />,
      title: 'Wsparcie IT',
      description: 'Kompleksowe wsparcie techniczne i helpdesk dla Twojej firmy - zawsze gdy potrzebujesz pomocy.',
      category: 'support',
      color: 'primary',
      link: '/uslugi/wsparcie',
      buttonText: 'Zapewnij ciągłość działania',
      detailedDescription: 'Zapewniamy kompleksowe wsparcie techniczne i helpdesk dla Twojej firmy. Nasz zespół specjalistów jest dostępny, aby rozwiązywać problemy techniczne, udzielać wsparcia użytkownikom oraz zapewnić ciągłość działania Twojej infrastruktury IT.'
    },
    {
      id: 'network',
      icon: <FaNetworkWired size={36} />,
      title: 'Sieci i Wi-Fi',
      description: 'Projektowanie i konfiguracja niezawodnych sieci firmowych i rozwiązań Wi-Fi.',
      category: 'infrastructure',
      color: 'info',
      link: '/uslugi/sieci',
      buttonText: 'Zoptymalizuj swoją sieć',
      detailedDescription: 'Projektujemy, wdrażamy i utrzymujemy niezawodne sieci firmowe oraz rozwiązania Wi-Fi. Oferujemy optymalizację istniejącej infrastruktury sieciowej, wdrażanie nowych rozwiązań oraz zapewnienie stabilnego i bezpiecznego dostępu do internetu.'
    }
  ];

  // Pobieranie punktów oferty dla wybranej usługi
  const getServiceOfferPoints = (serviceId) => {
    switch(serviceId) {
      case 'infrastructure':
        return [
          'Kompleksowa analiza obecnej infrastruktury i identyfikacja obszarów wymagających optymalizacji',
          'Projektowanie i wdrażanie rozwiązań serwerowych, pamięci masowych i systemów kopii zapasowych',
          'Konfiguracja i zarządzanie całą infrastrukturą IT z naciskiem na niezawodność i wydajność',
          'Regularne audyty i konserwacja sprzętu, aby zapewnić jego optymalną pracę przez długi czas'
        ];
      case 'security':
        return [
          'Audyt bezpieczeństwa i identyfikacja potencjalnych zagrożeń w systemach informatycznych firmy',
          'Wdrożenie kompleksowych rozwiązań bezpieczeństwa, w tym firewalli, systemów antywirusowych i antymalware',
          'Szkolenia pracowników z zakresu cyberbezpieczeństwa i dobrych praktyk ochrony danych',
          'Monitoring i szybka reakcja na incydenty bezpieczeństwa, minimalizująca ryzyko wycieku danych'
        ];
      case 'development':
        return [
          'Projektowanie intuicyjnych i responsywnych stron internetowych i aplikacji dostosowanych do potrzeb Twojego biznesu',
          'Tworzenie rozwiązań z wykorzystaniem nowoczesnych technologii, zapewniających optymalną wydajność',
          'Testowanie i wdrażanie funkcjonalności, które zwiększają zaangażowanie użytkowników i konwersję',
          'Wsparcie powdrożeniowe i rozwój oprogramowania zgodnie z ewoluującymi potrzebami biznesowymi'
        ];
      case 'cloud':
        return [
          'Analiza procesów biznesowych i rekomendacje dotyczące migracji do chmury',
          'Bezpieczne przeniesienie danych i aplikacji do środowiska chmurowego',
          'Konfiguracja usług chmurowych z naciskiem na skalowalność i optymalizację kosztów',
          'Szkolenia zespołu z efektywnego wykorzystania narzędzi chmurowych w codziennej pracy'
        ];
      case 'support':
        return [
          'Całodobowy helpdesk i wsparcie techniczne dla pracowników Twojej firmy',
          'Szybkie rozwiązywanie problemów zarówno zdalnie, jak i w siedzibie firmy',
          'Proaktywne monitorowanie systemów, pozwalające zapobiegać potencjalnym problemom',
          'Regularne raporty i rekomendacje dotyczące optymalizacji infrastruktury IT'
        ];
      case 'network':
        return [
          'Projektowanie optymalnej infrastruktury sieciowej dostosowanej do specyfiki budynku i potrzeb firmy',
          'Wdrażanie wydajnych i bezpiecznych rozwiązań Wi-Fi z zasięgiem w całym obiekcie',
          'Konfiguracja segmentacji sieci i polityk bezpieczeństwa chroniących dane firmowe',
          'Monitoring i optymalizacja przepustowości sieci, aby zapewnić stabilne połączenie dla wszystkich urządzeń'
        ];
      default:
        return [
          'Kompleksowa analiza potrzeb i przygotowanie rozwiązania odpowiadającego specyficznym wymaganiom Twojej firmy',
          'Profesjonalne wdrożenie według ustalonego harmonogramu, z minimalnym wpływem na bieżącą działalność firmy',
          'Szkolenie i wsparcie techniczne dla pracowników, aby zapewnić płynne przejście na nowe rozwiązania',
          'Kompleksowe wsparcie posprzedażowe i serwis, zapewniające ciągłość działania wdrożonych rozwiązań'
        ];
    }
  };

  // Otwórz modal z szczegółami usługi
  const openServiceModal = (serviceId) => {
    setSelectedService(serviceId);
  };

  // Zamknij modal
  const closeServiceModal = () => {
    setSelectedService(null);
  };

  // Pobranie wybranej usługi
  const getSelectedService = () => {
    return services.find(service => service.id === selectedService);
  };

  // Animacje
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: 'spring', stiffness: 50 }
    }
  };

  return (
    <div id="services" className="py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <span className="text-primary font-medium text-sm tracking-wider uppercase mb-2 inline-block">Co oferujemy</span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Nasze <span className="text-primary">Usługi</span>
          </h2>
          <p className="text-foreground-muted max-w-2xl mx-auto">
            Oferujemy przystępne rozwiązania IT dla firm każdej wielkości.
            Technologia nie musi być skomplikowana - sprawdzimy, co naprawdę potrzebujesz i dostarczymy to w zrozumiały sposób.
          </p>
        </motion.div>

        {/* Siatka usług - zmniejszona liczba usług */}
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
        >
          {services.map((service, index) => (
            <motion.div
              key={service.id}
              variants={itemVariants}
              whileHover={{ y: -10, transition: { duration: 0.3 } }}
              className="h-full" // Zapewnia pełną wysokość dla karty
            >
              <Card className={`shadow-lg border-t-4 border-${service.color} h-full flex flex-col`}>
                <CardHeader className="flex items-center justify-center pt-6 pb-4">
                  <motion.div
                    animate={{ rotate: [0, 5, 0, -5, 0] }}
                    transition={{ duration: 5, repeat: Infinity }}
                    className={`text-${service.color}`}
                  >
                    {service.icon}
                  </motion.div>
                </CardHeader>
                <Divider />
                <CardBody className="flex-grow">
                  <h3 className="text-xl font-semibold mb-3 text-center">{service.title}</h3>
                  <p className="text-foreground-muted text-center">{service.description}</p>
                </CardBody>
                <CardFooter className="flex justify-end items-center">
                  <Button 
                    color={service.color}
                    size="sm"
                    endContent={<FaArrowRight size={12} />}
                    onPress={() => openServiceModal(service.id)}
                  >
                    Szczegóły
                  </Button>
                </CardFooter>
              </Card>
            </motion.div>
          ))}
        </motion.div>
        
        {/* Call to action */}
        <motion.div 
          className="mt-16 text-center"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
        >
          <Card className="max-w-4xl mx-auto border border-primary/10 shadow-lg bg-gradient-to-r from-primary/5 to-secondary/5">
            <CardBody className="py-8 px-6">
              <h3 className="text-xl md:text-2xl font-bold mb-4">Nie wiesz, czego potrzebujesz?</h3>
              <p className="text-foreground-muted mb-6 max-w-xl mx-auto">
                Pomożemy Ci określić, jakie rozwiązania IT będą najlepsze dla Twojej firmy.
                Skontaktuj się z nami, aby umówić się na konsultację.
              </p>
              <Button 
                as="a" 
                href="/kontakt" 
                color="primary" 
                size="lg"
                endContent={<FaArrowRight />}
              >
                Umów konsultację
              </Button>
            </CardBody>
          </Card>
        </motion.div>
      </div>

      {/* Modal z szczegółami usługi */}
      {selectedService && (
        <Modal 
          isOpen={!!selectedService} 
          onClose={closeServiceModal}
          size="2xl"
          classNames={{
            backdrop: "bg-black/50 backdrop-blur-sm",
            base: "border border-primary/10 shadow-xl max-h-[90vh]",
            body: "p-6 overflow-auto"
          }}
        >
          <ModalContent>
            {() => {
              const service = getSelectedService();
              return (
                <>
                  <ModalHeader className={`text-${service.color} flex items-center gap-3 pb-2 pt-6 px-6`}>
                    <div className={`p-2 rounded-lg bg-${service.color}/10 text-${service.color}`}>
                      {service.icon}
                    </div>
                    <div className="flex-grow">
                      <h2 className="text-2xl font-bold">{service.title}</h2>
                      <Chip color={service.color} variant="flat" size="sm" className="mt-1">
                        {service.category === 'infrastructure' ? 'Infrastruktura' : 
                         service.category === 'software' ? 'Oprogramowanie' : 
                         service.category === 'security' ? 'Bezpieczeństwo' : 'Wsparcie'}
                      </Chip>
                    </div>
                  </ModalHeader>
                  <Divider />
                  <ModalBody>
                    <div className="p-2">
                      <h3 className="text-lg font-semibold mb-4">Szczegółowy opis usługi</h3>
                      <p className="text-foreground-muted mb-6">{service.detailedDescription}</p>
                      
                      <h3 className="text-lg font-semibold mb-4">Co oferujemy w ramach usługi?</h3>
                      <ul className="space-y-3 mb-6">
                        {getServiceOfferPoints(service.id).map((point, index) => (
                          <li key={index} className="flex items-start gap-3">
                            <div className={`p-1 rounded-full text-${service.color} mt-1 flex-shrink-0`}>
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                            <span>{point}</span>
                          </li>
                        ))}
                      </ul>
                      
                      <div className="mt-8 text-center">
                        <p className="mb-4 text-foreground-muted">Potrzebujesz tej usługi dla swojej firmy?</p>
                        <Button 
                          as="a"
                          href="/kontakt" 
                          color={service.color} 
                          size="lg"
                          className="px-8"
                        >
                          Skontaktuj się z nami
                        </Button>
                      </div>
                    </div>
                  </ModalBody>
                  <Divider />
                  <ModalFooter className="px-6 py-4 flex justify-center">
                    <Button 
                      variant="light" 
                      onPress={closeServiceModal}
                      size="lg"
                    >
                      Zamknij
                    </Button>
                  </ModalFooter>
                </>
              );
            }}
          </ModalContent>
        </Modal>
      )}
    </div>
  );
};

export default Services;